exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* body {\n  margin: 0;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.labelFont {\n  margin-top: 6px;\n  font-weight: bold;\n  float: right;\n  font-size: 16px;\n  margin-right: 40px;\n} */\n", ""]);

